module.exports = __webpack_public_path__ + "static/media/visitor.6c0c84e6.png";